import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { formatDate } from "@/core/utils/date";
import { getCustomerNameOrPhone } from "@/customer/utils";
import { ReferralOptionsDropdown } from "@/referrals/common/referral-options-dropdown";
import type { IReferral } from "@/referrals/referral";

interface NameAndDateProps {
  referral: IReferral;
  hideDate?: boolean;
  onLost?: () => void;
  onMoveToPaid?: () => void;
  onDelete?: () => void;
}

export const NameAndDateSkeleton = ({ showDate }: { showDate?: boolean }) => (
  <Stack
    className="w-full"
    gap={4}
    direction="row"
    justify="between"
    align="start"
  >
    <Stack align="start" gap={1}>
      <Skeleton className="h-4 w-36" />
      {showDate && <Skeleton className="h-3 w-20" />}
    </Stack>
    <Skeleton className="h-6 w-6 rounded-full" />
  </Stack>
);

export const NameAndDate = ({
  referral,
  hideDate,
  onLost,
  onMoveToPaid,
  onDelete,
}: NameAndDateProps) => (
  <Stack
    className="w-full"
    gap={4}
    direction="row"
    justify="between"
    align="start"
  >
    <Stack align="start" gap={1} className="min-w-0">
      <Text
        variant="label"
        render={<button type="button" />}
        className="rounded-sm text-left outline-none focus-visible:ring-3 focus-visible:ring-focus/50"
      >
        {getCustomerNameOrPhone(referral.potential_customer)}
      </Text>
      {!hideDate && (
        <Text variant="caption" tone="muted">
          {formatDate(referral.created_at) || "No date"}
        </Text>
      )}
    </Stack>
    <ReferralOptionsDropdown
      referral={referral}
      onLost={onLost}
      onMoveToPaid={onMoveToPaid}
      onDelete={onDelete}
      className="-mt-1 -mr-2"
    />
  </Stack>
);
